import Alpine from 'alpinejs';

document.addEventListener('alpine:init', () => {
    Alpine.store('popovers', {
        current: null,
        handlers: {},

        register(name, { close } = {}) {
            if (!name) return;
            this.handlers[name] = {
                close: typeof close === 'function' ? close : null
            };
        },

        isOpen(name) {
            return this.current === name;
        },

        open(name) {
            if (!name) return;
            if (this.current && this.current !== name) {
                this.close(this.current);
            }
            this.current = name;
        },

        close(name) {
            const target = name ?? this.current;
            if (!target) return;

            const handler = this.handlers[target]?.close;
            if (typeof handler === 'function') {
                handler();
            }

            if (this.current === target) {
                this.current = null;
            }
        },

        clear(name) {
            if (this.current === name) {
                this.current = null;
            }
        }
    });
});
